export default class Preregistration implements IDigitalIdentityHubModule {
  public name = "Preregistration";

  public init(): void { /* No functionality */ }

  public ready(): void {
    // setting hidden fields preregEmailHidden, userStatusHidden
    // related to preregistration done in hidden-fields.ts
    const registrationForms = ["shortRegistration", "traditionalRegistration"];

    // If the validation message is pre-registered submit reset password flow
    janrain.events.onCaptureValidationFailed.addHandler(function(result) {
      if (registrationForms.indexOf(janrain.settings.capture.currentScreenName) > -1) {
        if (result.field.id === `capture_${janrain.settings.capture.currentScreenName}_preregEmailAddress` && result.message === "pre-registered") {
          const translated = window.DigitalIdentityHub.utilities.translate("pre-registered");
          if (translated) {
            const errorDiv = result.parentDiv.querySelector(".capture_tip_error");

            if (errorDiv) {
              errorDiv.innerHTML = window.DigitalIdentityHub.utilities.translate("pre-registered");
            }
          }
          document.querySelector(".capture_tip_error")!.remove();
          window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "createPasswordEmailAddress");
          window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "createPasswordEmailAddress")!.value = result.field.value;
          janrain.capture.ui.postCaptureForm("createPasswordForm");
        }
      }
    });

    // User is not pre-reg, transition to registration form
    janrain.events.onCaptureValidationSuccess.addHandler(function(result) {
      if (registrationForms.indexOf(janrain.settings.capture.currentScreenName) > -1) {

        // fix for scenario where preregEmailAddress field is in registrationForm & non-prereg used email was entered in preregEmailAddress
        // in this case when submitting registrationForm because of the success event on preregEmailAddress field the used email was copied back into email field
        // this prevents that causing issues
        if (result.field.id === `capture_${janrain.settings.capture.currentScreenName}_email`) {
          const preregField = window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "preregEmailAddress");
          if (preregField) {
            preregField.value = result.field.value;
          }
        }

        if (result.field.id === `capture_${janrain.settings.capture.currentScreenName}_preregEmailAddress`) {
          const preregForm = window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "preregForm");
          if (preregForm) {
            preregForm.style.display = "none";
          } else {
            window.DigitalIdentityHub.utilities.getCaptureFormItem(janrain.settings.capture.currentScreenName, "preregEmailAddress").style.display = "none";
          }
          window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "email")!.value = result.field.value;
          const emailSpan = document.getElementById("register_email");
          if (emailSpan == null || emailSpan.innerHTML == "") {
            window.DigitalIdentityHub.utilities.getCaptureFormItem(janrain.settings.capture.currentScreenName, "email")!.style.display = "block";
            window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "email")!.focus();
            window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "email")!.blur();
          }
        }
      }
    });

    // At the start make sure registration forms email field is not visible
    janrain.events.onCaptureRenderComplete.addHandler(function() {
      if (registrationForms.indexOf(janrain.settings.capture.currentScreenName) > -1) {
        const email = window.DigitalIdentityHub.utilities.getCaptureFormItem(janrain.settings.capture.currentScreenName, "email");

        if (email) {
          email.style.display = "none";
        }
        const preregEmailAddress = window.DigitalIdentityHub.utilities.getCaptureField(janrain.settings.capture.currentScreenName, "preregEmailAddress");
        if (preregEmailAddress) {
          preregEmailAddress.value = "";
        }
      }
    });
  }
}
